/*================ Brand Bar Factory
  ========================================*/
angular
  .module('vppApp')
  .factory('brandBarSSOFactory', brandBarSSOFactory);

brandBarSSOFactory.$inject = ['$http', '$rootScope', '$log', 'vppConfig', '$state', 'splitFilter', 'ProgramInfoService', 'VarientService'];

function brandBarSSOFactory($http, $rootScope, $log, vppConfig, $state, splitFilter, ProgramInfoService, VarientService) {
  return function() {

    var Url = vppConfig.brandBarContentPath + "brandBar-sso.json";
    var promise = $http.get(Url).then(function successCallback(data) {
      return data;
    }, function errorCallback(data) {
      return data;
    });

    return promise;
  };

 }
